import {
  Button,
  Input,
  MinthrSelect,
  Sidebar,
  TextArea,
} from 'components/common';
import FileUpload from 'components/common/FileUpload';
import { useSidebarManager } from 'contexts/SidebarManagerContext';
import {
  deleteInterventionFile,
  editIntervention,
  getInterventionById,
} from 'features/material/services/interventionServices';
import { Form, Formik } from 'formik';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { appendToFormData } from 'utils/globalMethodes';
import InfoIntervention from './InfoIntervention';
import MintErrorMessage from 'components/common/MintErrorMessage';
import useFetchData from 'hooks/useFetch';
import { InterventionCreate } from 'features/material/types/interventionTypes';

interface EditInterventionProps {
  id: number;
  refetch: () => void;
  parentRefetch: () => void;
}

const EditIntervention: FC<SideBarProps<EditInterventionProps>> = ({
  sidebar,
  setSidebarWidth,
  sidebarWidth,
  params,
}) => {
  const { t } = useTranslation();
  const { openSidebar, closeSidebar } = useSidebarManager();
  const [error, setError] = useState<string>('');

  const { data: intervention, refetch } = useFetchData(getInterventionById, [
    params.id,
  ]);

  const handleSubmit = async (values: InterventionCreate) => {
    console.log('values', values);
    const formData = appendToFormData(values);
    const res = await editIntervention(formData);
    if (res.success) {
      toast.success(t('Default.succesMessage'));
      closeSidebar(EditIntervention);
      params?.refetch?.();
      params?.parentRefetch?.();
      openSidebar(InfoIntervention, true, {
        id: params.id,
        refetch: params?.parentRefetch,
      });
    } else {
      setError(res.message);
    }
  };

  const deleteFile = async (fileId: number) => {
    const response = await deleteInterventionFile(fileId);
    if (response.success) {
      toast.success(t('Default.succesMessage'));
      refetch?.();
    } else {
      toast.error(response.message);
    }
  };

  const initilaValues: InterventionCreate = {
    ...intervention?.data,
    id: intervention?.data?.id ?? 0,
    nbrActions: intervention?.data?.nbrActions ?? 0,
    isProfile: intervention?.data?.isProfile ?? false,
    fullModal: intervention?.data?.fullModal ?? false,
    generale: intervention?.data?.generale ?? false,
    whoDid: null,
    demandeByUser: null,
    history: null,
    users: null,
  };

  return (
    <Sidebar
      size="m"
      type="primary"
      sidebar={sidebar}
      setSidebarWidth={setSidebarWidth}
      sidebarWidth={sidebarWidth}
    >
      <div>
        <div className="minthr-flex minthr-flex-items-center minthr-pb-2 minthr-mb-4 minthr-border-b minthr-border-b-3">
          <div className="minthr-icon-bg minthr-icon-bg-l minthr-icon-bg-secondary minthr-icon-circle minthr-mr-3">
            <img
              className="minthr-icon-m"
              src="/icons/intervention.svg"
              alt=""
            />
          </div>
          <h3>{t('Intervention.edit.Title')}</h3>

          <button
            className="minthr-sidebar-close"
            type="button"
            onClick={() => closeSidebar(EditIntervention)}
          >
            <img src="/icons/close.svg" alt="" />
          </button>
        </div>
        <Formik
          initialValues={initilaValues}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <Form className="w-100">
              <div className="minthr-pt-2 minthr-flex minthr-flex-column">
                {error && <MintErrorMessage message={error} />}
                <div className="row g-0 minthr-mb-5">
                  <div className="col-sm-12">
                    <MinthrSelect
                      options={[
                        { value: 2, label: t('Material.Type.General') },
                        { value: 0, label: t('Material.Type.Software') },
                        { value: 1, label: t('Material.Type.Material') },
                      ]}
                      label={t('Itervention.Create.f.Type')}
                      name="hardware"
                      onchange={(e: { value: number; label: string }) => {
                        setFieldValue('hardware', e.value);
                      }}
                    />
                  </div>
                </div>

                <div className="row g-0 minthr-mb-5 material-div">
                  <div className="col-sm-12">
                    <MinthrSelect
                      options={
                        intervention?.data?.inventaires?.map(
                          (material: SelectItem) => ({
                            value: material.value || '',
                            label: material.text,
                          }),
                        ) ?? []
                      }
                      label={t('Approval.F.Fk_Type')}
                      name="fk_Material"
                    />
                  </div>
                </div>
                <div className="row g-0 minthr-mb-5">
                  <div className="col-sm-12">
                    <Input
                      label={t('Itervention.Create.f.Title')}
                      name="title"
                      type="text"
                    />
                  </div>
                </div>
                <div className="row g-0 minthr-mb-5">
                  <div className="col-sm-12">
                    <MinthrSelect
                      options={[
                        { value: '0', label: t('Software.Type.incident') },
                        { value: '1', label: t('Software.Type.Request') },
                        { value: '2', label: t('Software.Type.Technical') },
                      ]}
                      label={t('Intervention.filter.TypeIntervention')}
                      name="type"
                    />
                  </div>
                </div>
                <div className="row g-0 minthr-mb-5">
                  <div className="col-3">
                    <label className="minthr-badge-check">
                      <input
                        type="radio"
                        id="Urgent"
                        name="priority"
                        value="Urgent"
                        checked={values.priority === 'Urgent'}
                        onChange={() => setFieldValue('priority', 'Urgent')}
                      />
                      <a className="minthr-flex minthr-flex-items-center minthr-badge minthr-badge-danger minthr-px-3  minthr-mobile-ml-0 minthr-mobile-mb-4 minthr-mobile-w-100">
                        <h5
                          className={`minthr-mr-2 ${
                            values.priority === 'Urgent'
                              ? 'minthr-color-white'
                              : 'minthr-color-dark'
                          }`}
                        >
                          {t('Hardware.edit.f.urgent')}
                        </h5>
                      </a>
                    </label>
                  </div>
                  <div className="col-3">
                    <label className="minthr-badge-check">
                      <input
                        type="radio"
                        id="High"
                        name="priority"
                        value="High"
                        checked={values.priority === 'High'}
                        onChange={() => setFieldValue('priority', 'High')}
                      />
                      <a className="minthr-flex minthr-flex-items-center minthr-badge minthr-badge-warning minthr-px-3  minthr-mobile-ml-0 minthr-mobile-mb-4 minthr-mobile-w-100">
                        <h5
                          className={`minthr-mr-2 ${
                            values.priority === 'High'
                              ? 'minthr-color-white'
                              : 'minthr-color-dark'
                          }`}
                        >
                          {t('Hardware.edit.f.high')}
                        </h5>
                      </a>
                    </label>
                  </div>
                  <div className="col-3">
                    <label className="minthr-badge-check">
                      <input
                        type="radio"
                        id="Normal"
                        name="priority"
                        value="Normal"
                        checked={values.priority === 'Normal'}
                        onChange={() => setFieldValue('priority', 'Normal')}
                      />
                      <a className="minthr-flex minthr-flex-items-center minthr-badge minthr-badge-info minthr-px-3  minthr-mobile-ml-0 minthr-mobile-mb-4 minthr-mobile-w-100">
                        <h5
                          className={`minthr-mr-2 ${
                            values.priority === 'Normal'
                              ? 'minthr-color-white'
                              : 'minthr-color-dark'
                          }`}
                        >
                          {t('Hardware.edit.f.normal')}
                        </h5>
                      </a>
                    </label>
                  </div>
                  <div className="col-3">
                    <label className="minthr-badge-check">
                      <input
                        type="radio"
                        id="Low"
                        name="priority"
                        value="Low"
                        checked={values.priority === 'Low'}
                        onChange={() => setFieldValue('priority', 'Low')}
                      />
                      <a className="minthr-flex minthr-flex-items-center minthr-badge minthr-badge-success minthr-px-3 minthr-mobile-ml-0 minthr-mobile-mb-4 minthr-mobile-w-100">
                        <h5
                          className={`minthr-mr-2 ${
                            values.priority === 'Low'
                              ? 'minthr-color-white'
                              : 'minthr-color-dark'
                          }`}
                        >
                          {t('Hardware.edit.f.low')}
                        </h5>
                      </a>
                    </label>
                  </div>
                </div>
                <div className="row g-0 minthr-mb-5">
                  <div className="col-sm-12 ">
                    <TextArea
                      label={t('F.Description')}
                      name="description"
                      rows={4}
                    />
                  </div>
                </div>
                <div className="row g-0 minthr-mb-5">
                  <div className="col-sm-12">
                    <FileUpload
                      name="files"
                      allowedFileTypes={[
                        'jpg',
                        'jpeg',
                        'png',
                        'gif',
                        'pdf',
                        'doc',
                        'docx',
                        'xls',
                        'xlsx',
                      ]}
                      // customizeUpload={true}
                      initialFiles={values.files ?? []}
                      labelClass=""
                      labelText={t('Uplaod.file')}
                      containerClass="minthr-files minthr-border-rounded minthr-bg-primary-opacity minthr-p-6"
                      imageClass="minthr-icon-xl minthr-mb-3"
                      filesContainerClassName="minthr-mt-5"
                      targetContainerId="fileUploadContainer"
                    />
                  </div>
                </div>
              </div>
              <div className="minthr-sidebar-content-files new row">
                {intervention?.data?.filesNames &&
                  intervention?.data?.filesNames?.length > 0 && (
                    <div className="row g-0 minthr-mb-5">
                      <div id="fileUploadContainer"></div>
                      {intervention?.data?.filesNames?.map((item: FileType) => (
                        <div className="col-sm-12" key={item.id}>
                          <div className="minthr-flex minthr-flex-items-center minthr-bg-light-gray minthr-text-decoration-none minthr-p-2 minthr-border-rounded minthr-mb-3">
                            <img
                              className="minthr-icon-xl minthr-mr-2"
                              src="/icons/doc-file.svg"
                              alt=""
                            />
                            <div className="minthr-mr-6 minthr-pr-3">
                              <h6>{item.name}</h6>
                              <div className="text-s"></div>
                            </div>

                            <button
                              type="button"
                              className="minthr-p-0 minthr-border-none minthr-bg-transparent minthr-ml-auto minthr-mr-2 file-delete"
                              onClick={() => deleteFile(item.id)}
                            >
                              <img
                                className="minthr-icon-s minthr-icon-danger"
                                src="/icons/delete.svg"
                                alt=""
                              />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
              </div>
              <div className="minthr-sidebar-footer minthr-box-shadow minthr-flex minthr-flex-items-center minthr-flex-space-between minthr-py-4 minthr-mx-n5 minthr-px-4 minthr-mt-auto">
                <Button
                  type="submit"
                  loading={isSubmitting}
                  className="minthr-btn minthr-btn-primary minthr-ml-auto"
                >
                  {t('submit')}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Sidebar>
  );
};

export default EditIntervention;
